<h3 class="font-extrabold mb-6">{{ data.title }}</h3>

<div class="flex flex-col w-full">
  <div *ngFor="let file of data.files; let odd = odd"
       class="flex items-center justify-between w-full bg-white border border-gray-200 p-2"
       [ngClass]="{ 'bg-gray-200': odd }">

    <div class="flex flex-col">
      <span>{{ file.name }}</span>
      <span>{{ file.createdAt | momentFormat: 'default' }}</span>
    </div>

    <div>
      <button (click)="openFile(file.url)" class="flex items-center ml-2 icon-action">
        <mat-icon>visibility</mat-icon>
      </button>
    </div>
    
  </div>
</div>